/** @jsx h */
import { h } from 'preact'
import { useEffect, useState } from 'preact/compat'
import './main.css'
import Appointment from './components/appointment'

import { getMaisonConfig, getAllCountries, getPhonesValidation } from './api'

import { GlobalProvider } from './use-global'
import { LabelProvider } from './use-label'

const App = ({
  selector,
  maisonId,
  apiBaseUrl,
  country,
  boutiqueId,
  homeLink,
  locale,
  useAnalytics,
  analyticsDriver,
  tcId,
  analyticsCountry,
  analyticsLocale,
  internalComments,
  showPrintIcon,
  direction,
  povESFY,
  povNGCS,
  hasStrap,
  isPickUp,
  isClickNCollect,
  colors,
  onSectionExpanded
}) => {
  const [conf, setConf] = useState()
  const [countries, setCountries] = useState()
  const [phonesValidation, setPhonesValidation] = useState()

  const [error, setError] = useState()

  useEffect(() => {
    Promise.all([
      getMaisonConfig({ apiBaseUrl, maisonId, language: locale }),
      getAllCountries({ apiBaseUrl, language: locale }),
      getPhonesValidation({ apiBaseUrl })
    ])
      .then(values => {
        setConf(values[0])
        setCountries(values[1])
        setPhonesValidation(values[2])
      })
      .catch(err => {
        // todo handle error
        console.log(err)
        setError(true)
      })
  }, [locale, maisonId, apiBaseUrl])

  if (error) {
    return (
      <div className='rcc-flex rcc-flex-col rcc-gap-5 rcc-font-widget'>
        <h1 className='rcc-text-center rcc-m-0 rcc-text-8xl '>Oops!</h1>
        <h2 className='rcc-text-center rcc-m-0 rcc-uppercase'>Sorry, something went wrong.</h2>
      </div>
    )
  }

  return (
    <div className='RCCanvasWidget'>
      {conf && countries ? (
        <GlobalProvider
          canvasConfig={{
            maisonName: conf?.configurations?.name,
            selector,
            maisonId,
            apiBaseUrl,
            country,
            boutiqueId,
            homeLink,
            locale,
            useAnalytics,
            analyticsDriver,
            tcId,
            analyticsCountry,
            analyticsLocale,
            internalComments,
            showPrintIcon,
            direction,
            povESFY,
            povNGCS,
            hasStrap,
            isPickUp,
            isClickNCollect,
            colors,
            onSectionExpanded
          }}
        >
          <LabelProvider labels={conf.labels}>
            <Appointment conf={conf} countries={countries} phoneValidation={phonesValidation} />
          </LabelProvider>
        </GlobalProvider>
      ) : null}
    </div>
  )
}

export default App
